import { render, staticRenderFns } from "./WaveFormLoadingPlaceholder.vue?vue&type=template&id=5998c3b4&scoped=true&"
import script from "./WaveFormLoadingPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./WaveFormLoadingPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./WaveFormLoadingPlaceholder.vue?vue&type=style&index=0&id=5998c3b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998c3b4",
  null
  
)

export default component.exports